import { useCallback, useEffect, useMemo, useState } from 'react'

import { CommonGAssets } from '@hhgtech/hhg-components/gAssets'
import { Text } from '@hhgtech/hhg-components/mantine'
import { AspectRatio, Box, BoxProps, Stack, rem } from '@mantine/core'

import { callApiNew } from 'api/axios'
import { PATHS } from 'api/paths'
import { Container } from 'components/atoms/container'
import { NextImageWrap } from 'components/atoms/imageWrap'
import { Loading } from 'components/atoms/loading'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useIsMobile } from 'hooks/useIsMobile'
import { SpotlightVideoSession } from 'interfaces/types'

import useStyles from './index.styles'
import { CarouselOrListingBlockWrapper } from '../carouselOrListingBlockWrapper'
import { VideoItem } from '../videoLibrary/videoItem'
export type ShortReelListProps = {
  sessionProps: SpotlightVideoSession
} & BoxProps

const ShortReelList = ({
  sessionProps,
  styles,
  ...boxProps
}: ShortReelListProps) => {
  const isMobile = useIsMobile()
  const [videosInfo, setVideosInfo] = useState<VideoItem[]>([])
  const hasSlider = useMemo(() => videosInfo.length > 2, [videosInfo])
  const { classes, cx } = useStyles(
    { hasSlider },
    { name: 'ShortReelList', styles },
  )
  const { title, videoList = [] } = sessionProps
  const currentUrl = useCurrentUrl()
  const [loading, setLoading] = useState(false)
  const fetchPreview = useCallback(async () => {
    try {
      setLoading(true)
      const res = await Promise.all(
        videoList.map((i) =>
          callApiNew(
            PATHS.TOGETHER.FETCH_PREVIEW,
            {
              method: 'POST',
              data: {
                link: i.urlVideo,
              },
            },
            'together',
          ),
        ),
      )
      setLoading(false)
      const dataRes: VideoItem[] = res
        .map((i, idx) => {
          return (
            i?.data && {
              ...i.data,
              url: videoList[idx].urlVideo,
              title: videoList[idx].videoTitle || i.title,
            }
          )
        })
        .filter(Boolean)
      if (dataRes.length > 0) {
        setVideosInfo(dataRes)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    videoList.length > 0 && fetchPreview()
  }, [])

  return videoList.length > 0 ? (
    <Box className={classes.root} {...boxProps}>
      <Container className={classes.container}>
        <Stack
          spacing={rem(40)}
          sx={(theme) => ({
            gap: rem(24),
            [theme.fn.largerThan('sm')]: { gap: rem(40) },
          })}
        >
          {title && (
            <Text size="h2" as={'h2'} className={classes.heading}>
              {title}
            </Text>
          )}

          {loading ? (
            <Loading />
          ) : videosInfo.length > 0 ? (
            <Box className={classes.body}>
              <Box className={classes.thumbnail}>
                <img
                  src={CommonGAssets.getAssetPath(
                    isMobile
                      ? 'tiki/tamdiem-mb.png'
                      : 'tiki/tamdiem-desktop.png',
                  )}
                  alt={'Tâm điểm'}
                  loading="lazy"
                />
              </Box>
              <Box className={classes.listing}>
                <CarouselOrListingBlockWrapper
                  lengthToCarouselDesktop={3}
                  gapDesktop={24}
                  carouselSetting={{
                    withIndicators: false,
                  }}
                >
                  <CarouselOrListingBlockWrapper.Slider>
                    {videosInfo.map((i, idx) => (
                      <a
                        href={i.url}
                        target="_blank"
                        key={idx}
                        className={classes.item}
                        data-event-category="Service Connection"
                        data-event-action="Livestream highlight Video"
                        data-event-label={currentUrl}
                      >
                        <AspectRatio
                          ratio={240 / 431}
                          className={classes.itemThumb}
                        >
                          <NextImageWrap
                            src={i.image || ''}
                            className={classes.itemThumbImg}
                            alt={i.title}
                            loading="lazy"
                            fill
                          />
                          {/* <img
                            src={i.image}
                            className={classes.itemThumbImg}
                            alt={i.title}
                            loading="lazy"
                          /> */}
                          <Box
                            className={cx(
                              classes.overlayWrapper,
                              'item-overlay-wrapper',
                            )}
                          >
                            <Box
                              className={cx(classes.overlay, 'item-overlay')}
                            >
                              <Text
                                size="s3"
                                color="#fff"
                                className={cx(classes.title, 'item-title')}
                              >
                                {i.title}
                              </Text>
                            </Box>
                          </Box>
                        </AspectRatio>
                      </a>
                    ))}
                  </CarouselOrListingBlockWrapper.Slider>
                </CarouselOrListingBlockWrapper>
              </Box>
            </Box>
          ) : null}
        </Stack>
      </Container>
    </Box>
  ) : null
}

export { ShortReelList }
